import ApiCore from '@/api/api-core'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class ReportsSettlementDriver extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/report/settlement/driver`)
  }

  report(filter, showProgress) {
    return this._request({
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
